import { Img } from 'openimg/react'
import { useRef } from 'react'
import { Link, Form } from 'react-router'
import { getUserImgSrc } from '#app/utils/misc.tsx'
import { useUser, userHasRole } from '#app/utils/user.ts'
import {
	DropdownMenu,
	DropdownMenuTrigger,
	DropdownMenuPortal,
	DropdownMenuContent,
	DropdownMenuItem,
} from './ui/dropdown-menu'
import { Icon } from './ui/icon'

export function UserDropdown() {
	const user = useUser()
	const formRef = useRef<HTMLFormElement>(null)
	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				<button
					className="group relative min-w-0 flex-1 cursor-pointer items-center justify-center gap-2 overflow-hidden rounded-r-lg bg-white px-4 py-4 text-center text-sm font-medium text-gray-500 hover:bg-gray-50 hover:text-gray-700 focus:z-10 focus:outline-none focus-visible:text-gray-900"
					aria-label="User menu"
				>
					<span
						aria-hidden="true"
						className="absolute inset-x-0 bottom-0 h-0.5 bg-transparent group-focus-visible:bg-indigo-500"
					/>
					<span className="inline-flex items-center gap-2">
						<Img
							className="size-5 rounded-full object-cover"
							alt={user.name ?? user.displayUsername}
							src={getUserImgSrc(user.image?.objectKey)}
							width={256}
							height={256}
							aria-hidden="true"
						/>
						<span>{user.name ?? user.displayUsername}</span>
					</span>
				</button>
			</DropdownMenuTrigger>
			<DropdownMenuPortal>
				<DropdownMenuContent sideOffset={8} align="end">
					<DropdownMenuItem asChild>
						<Link prefetch="intent" to={`/users/${user.username}`}>
							<Icon className="text-body-md" name="avatar">
								Profile
							</Icon>
						</Link>
					</DropdownMenuItem>
					{userHasRole(user, 'event-admin') ? (
					<DropdownMenuItem asChild>
						<Link prefetch="intent" to="/admin/events">
							<Icon className="text-body-md" name="clock">
								Manage Events
							</Icon>
						</Link>
					</DropdownMenuItem>
				) : null}
				{userHasRole(user, 'car-show-admin') ? (
					<DropdownMenuItem asChild>
						<Link prefetch="intent" to="/admin/car-show">
							<Icon className="text-body-md" name="file-text">
								Manage Car Show
							</Icon>
						</Link>
					</DropdownMenuItem>
				) : null}
				{userHasRole(user, 'super-admin') ? (
						<DropdownMenuItem asChild>
							<Link prefetch="intent" to="/admin/users">
								<Icon className="text-body-md" name="avatar">
									Manage Users
								</Icon>
							</Link>
						</DropdownMenuItem>
					) : null}
					<Form action="/logout" method="POST" ref={formRef}>
						<DropdownMenuItem asChild>
							<button type="submit" className="w-full">
								<Icon className="text-body-md" name="exit">
									Logout
								</Icon>
							</button>
						</DropdownMenuItem>
					</Form>
				</DropdownMenuContent>
			</DropdownMenuPortal>
		</DropdownMenu>
	)
}
